import { Components, Theme } from '@mui/material/styles';

export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: {
    'html, body': {
      scrollBehavior: 'smooth',
    },
  },
};
